import { useTranslation } from 'react-i18next';

import { getMeanType } from 'services/types';
import { DispatcherPass } from './mean-info-item.styled';

export const MeanInfoItem = (props) => {
  const { data, mean_type, mean_number, reverse = false } = props;
  const { t } = useTranslation();
  if (!data) {
    return null;
  }
  const { dispatcher_pass, operator_pass, free_mode, unauthorized } = data;
  if (!dispatcher_pass && !operator_pass && !free_mode && !unauthorized) {
    return null;
  }

  const getTitle = () => {
    if (unauthorized) {
      return 'Несанкционированный проезд';
    }
    if (free_mode) {
      return 'Проезд в свободном режиме';
    }
    if (operator_pass) {
      return 'Шлагбаум открыт диспетчером';
    }
    if (!operator_pass && dispatcher_pass) {
      return 'Шлагбаум открыт диспетчером';
    }
  };

  const title = getTitle();
  if (!title && reverse) {
    return null;
  }
  if (!title && !reverse) {
    const meanType = getMeanType(mean_type);
    const meanNumber = mean_number;
    return meanType && meanNumber ? `${meanType} ${meanNumber}` : null;
  }

  const titleT = t('messages.' + title);

  return (
    <DispatcherPass $reverse={reverse}>
      {titleT}
      <img src="/images/dispatcher-pass.png" alt="" />
    </DispatcherPass>
  );
};
